import { MouseEvent } from "react";
import { Tuple } from "./general";
import { FlowioInputProps } from "../components/atoms/inputs/FlowioInput";

export enum FlowioInputType {
  Checkbox = "checkbox",
  Color = "color",
  DateRange = "dateRange",
  Datetime = "Datetime",
  HegFiles = "hegFile",
  Hidden = "hidden",
  Icon = "icon",
  Number = "number",
  OverviewSelect = "overviewSelect",
  Password = "password",
  Select = "select",
  SelectWithSearch = "selectWithSearch",
  MultiSelect = "multiSelect",
  State = "state",
  Textarea = "textarea",
  Text = "text",
  Link = "link",
  Files = "file",
  IconAdmin = "iconAdmin",
}

export type DateType = string | null;
export type DateRangeTuple = Tuple<DateType>;

export type FlowioInputValue = FlowioInputProps["value"];

export interface SelectItem {
  id?: string;
  name: string;
  value: string;
  rangeValue?: Tuple<string | null> | null;
  isRange?: boolean | null;
}

export type ReactSelectSearchItem = {
  name: string;
  label: string;
  text: string;
  value: string;
  // rangeValue?: string[];
};

export type ButtonClickEvent = MouseEvent<HTMLButtonElement>;
export type ButtonClickCallback = (e: ButtonClickEvent) => void;
export type SubmitFormCallback = () => void;

export enum ButtonType {
  Button = "button",
  Submit = "submit",
  Reset = "reset",
}
